export enum CostPerEnum {
  HA = 'ha',
  H = 'h',
  KM = 'km',
  L = 'l',
}
